import { useMutation } from "react-query";

import { FnIntercom } from "#shared/intercom";

export const useIntercomBootUser = () =>
  useMutation<void, unknown, Intercom_.IntercomSettings>({
    mutationKey: "intercom-boot-user",
    mutationFn: (data) => FnIntercom.bootUser(data),
  });
